export const hedgingOrderLeverage = 1;
export const hedgingOrderSide = 'Short';
